export class UserInfo {
    id: string;
    name: string;
    email: string;
    role: string;
}
